// Internationalization (i18n) system
export class I18nManager {
    constructor() {
        this.currentLang = localStorage.getItem('language') || 'en';
        this.translations = {
            en: {
                // Header
                'title': 'Activate My Bitcoin 🔥',
                'disconnect': 'Disconnect',
                
                // Demo Banner
                'demo_banner': '🎮 Just Vibe',
                
                // Connect Section
                'connect_title': 'Activate Your Bitcoin Power! 🚀',
                'connect_wallet': 'Connect OP_NET Wallet',
                
                // Activation Section  
                'activate_button': 'ACTIVATE MY BITCOIN',
                'activating': 'Activating...',
                'activation_success': '✅ Bitcoin Activated Successfully!',
                'activation_error': '❌ Activation Failed',
                
                // Stats
                'your_stats': 'Your Stats 👤',
                'activations': 'Activations:',
                'rank': 'Rank:',
                'global_stats': 'Global Stats 🌍',
                'total_activations': 'Total Activations:',
                'total_users': 'Total Users:',
                'leaderboard': 'Leaderboard 🏆',
                'rank_position': 'Rank',
                'user_address': 'User Address',
                'activation_count': 'Count',
                
                // Transaction History
                'transaction_history': 'Transaction History 📜',
                'no_transactions': 'No transactions yet',
                'view_on_opscan': 'View on OPScan',
                'timestamp': 'Timestamp',
                'transaction_id': 'Transaction ID',
                'signature': 'Signature',
                
                // Music
                'music_toggle': 'Music',
                'music_on': 'Music On',
                'music_off': 'Music Off',
                
                // Footer
                'footer_text': 'Powered by Bitcoin & OP_NET',
                
                // Messages
                'wallet_connected': 'Wallet Connected',
                'wallet_disconnected': 'Wallet Disconnected',
                'activation_pending': 'Processing activation...',
                'please_connect_wallet': 'Please connect your wallet first',
                'activation_in_progress': 'Activation in progress...',
                
                // Error messages
                'wallet_connection_failed': 'Failed to connect wallet. ',
                'wallet_not_detected': 'OP_NET Wallet not detected. Reload page after installation.',
                'try_again_reload': 'Try again or reload the page.',
                
                // Transaction specific
                'activation': 'Activation',
                'transaction_sent': 'Transaction Sent',
                'signature_verified': 'Signature Verified',
                'signature': 'Signature',
                
                // Loading states
                'loading_leaderboard': 'Loading leaderboard...',
                'no_transactions': 'No transactions yet',
                'no_transactions_prompt': 'No transactions. Activate Bitcoin!'
            },
            ua: {
                // Header
                'title': 'Активуй Мій Біткоїн 🔥',
                'disconnect': 'Відключити',
                
                // Demo Banner
                'demo_banner': '🎮 Just Vibe',
                
                // Connect Section
                'connect_title': 'Активуй Силу Свого Біткоїна! 🚀',
                'connect_wallet': "Підключити OP_NET Гаманець",
                
                // Activation Section
                'activate_button': 'АКТИВУЙ МОЙ БІТКОЇН',
                'activating': 'Активація...',
                'activation_success': '✅ Біткоїн Успішно Активовано!',
                'activation_error': '❌ Помилка Активації',
                
                // Stats
                'your_stats': 'Ваша Статистика 👤',
                'activations': 'Активації:',
                'rank': 'Ранг:',
                'global_stats': 'Глобальна Статистика 🌍',
                'total_activations': 'Всього Активацій:',
                'total_users': 'Всього Користувачів:',
                'leaderboard': 'Таблиця Лідерів 🏆',
                'rank_position': 'Ранг',
                'user_address': 'Адреса Користувача',
                'activation_count': 'Кількість',
                
                // Transaction History
                'transaction_history': 'Історія Транзакцій 📜',
                'no_transactions': 'Транзакцій ще немає',
                'view_on_opscan': 'Переглянути на OPScan',
                'timestamp': 'Час',
                'transaction_id': 'ID Транзакції',
                'signature': 'Підпис',
                
                // Music
                'music_toggle': 'Музика',
                'music_on': 'Музика Ввімкнена',
                'music_off': 'Музика Вимкнена',
                
                // Footer
                'footer_text': 'Працює на Bitcoin та OP_NET',
                
                // Messages
                'wallet_connected': 'Гаманець Підключено',
                'wallet_disconnected': 'Гаманець Відключено',
                'activation_pending': 'Обробка активації...',
                'please_connect_wallet': 'Будь ласка, спочатку підключіть гаманець',
                'activation_in_progress': 'Активація в процесі...',
                
                // Error messages
                'wallet_connection_failed': 'Не вдалося підключити гаманець. ',
                'wallet_not_detected': 'OP_NET Wallet не виявлено. Перезавантажте сторінку після встановлення.',
                'try_again_reload': 'Спробуйте ще раз або перезавантажте сторінку.',
                
                // Transaction specific
                'activation': 'Активація',
                'transaction_sent': 'Транзакція відправлена',
                'signature_verified': 'Підписано',
                'signature': 'Підпис',
                
                // Loading states
                'loading_leaderboard': 'Завантаження лідерборду...',
                'no_transactions': 'Транзакцій ще немає',
                'no_transactions_prompt': 'Немає транзакцій. Активуйте Bitcoin!'
            }
        };
    }

    t(key) {
        return this.translations[this.currentLang][key] || key;
    }

    setLang(lang) {
        if (this.translations[lang]) {
            this.currentLang = lang;
            localStorage.setItem('language', lang);
            this.updateAllTexts();
        }
    }

    getCurrentLang() {
        return this.currentLang;
    }

    updateAllTexts() {
        // Update all elements with data-i18n attribute
        document.querySelectorAll('[data-i18n]').forEach(element => {
            const key = element.getAttribute('data-i18n');
            element.textContent = this.t(key);
        });

        // Update page title
        document.title = this.t('title');

        // Update music button title
        const musicToggle = document.getElementById('musicToggle');
        if (musicToggle) {
            musicToggle.title = this.t('music_toggle');
        }
    }

    init() {
        this.updateAllTexts();
    }
}
